import { Stack, Typography, TextField, Button, Backdrop, CircularProgress, Modal, Box, Autocomplete } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HorizontalDivider from 'src/components/shared/HorizontalDivider';
import Services from 'src/services/Services';
import { toast } from 'react-toastify';
import successImage from '../../assets/images/success-check.png';
import errorImage from '../../assets/images/error.png';
import { useLocalization } from 'src/context/LocalizationContext';

export default function CargoPartnerTakeEcommerce() {
    const { language } = useLocalization();
    const { partner } = useParams();
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [barcode, setBarcode] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalImage, setModalImage] = useState('');
    let partnerName = "";

    if (partner === "aras-kargo") {
        partnerName = "Aras Kargo";
    }

    else if (partner === "dhl") {
        partnerName = "DHL";
    }

    const handleAcceptReturn = () => {
        setLoading(true);
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        const token = parsedUser.token;

        if (partner === "aras-kargo") {
            Services.TakeEcommerce(token, selectedCompany.id, barcode.toString())
                .then((res) => {
                    setLoading(false);
                    if (res.data.status) {
                        setModalMessage('İşleminiz başarıyla tamamlanmıştır.');
                        setModalImage(successImage);
                    } else {
                        setModalMessage(res.data.message ? res.data.message : 'İşleminiz yapılırken bir hata oluştu.');
                        setModalImage(errorImage);
                    }
                    setIsModalOpen(true);
                })
                .catch((err) => {
                    setLoading(false);
                    setModalMessage(err.response?.data?.message ? err.response.data.message : 'İşleminiz yapılırken bir hata oluştu.');
                    setModalImage(errorImage);
                    setIsModalOpen(true);
                });
        }

        else if (partner === "dhl") {
            Services.DHLPackageApprove(token, barcode.toString())
                .then((res) => {
                    console.log("DHL C&C Res:", res.data);
                    setLoading(false);
                    if (res.data.status) {
                        setModalMessage('İşleminiz başarıyla tamamlanmıştır.');
                        setModalImage(successImage);
                    } else {
                        setModalMessage(res.data.message ? res.data.message : 'İşleminiz yapılırken bir hata oluştu.');
                        setModalImage(errorImage);
                    }
                    setIsModalOpen(true);
                })
                .catch((err) => {
                    setLoading(false);
                    setModalMessage(err.response?.data?.message ? err.response.data.message : 'İşleminiz yapılırken bir hata oluştu.');
                    setModalImage(errorImage);
                    setIsModalOpen(true);
                });
        }
    };

    function getPoints() {
        setLoading(true);
        const parsedUser = JSON.parse(localStorage.getItem('user'));
        const token = parsedUser.token;

        Services.GetPoints(token)
            .then((response) => {
                setLoading(false);
                if (response.data.status) {
                    // Örneğin sadece Aras Kargo ile çalışanları filtreleyelim
                    const arasKargoPoints = response.data.result.filter(x => x.isArasKargo === "1" || x.isArasKargo === true || x.isArasKargo === 1);
                    setCompanyList(arasKargoPoints);
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((error) => { toast.error(error.message); setLoading(false); });
    }

    useEffect(() => {
        if (partner === "aras-kargo") {
            getPoints();
        }
    }, []);

    const allFieldsAreValid = () => {
        if (partner === "aras-kargo") {
            return selectedCompany !== null && (barcode.trim().length === 8 || barcode.trim().length === 34);
        }
        else {
            return (barcode.trim().length > 0);;
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCompany(null);
        setBarcode('');
    };

    return (
        <>
            <Helmet>
                <title>{language.cargo_partners_refund.titles.site_title}</title>
            </Helmet>

            <Stack style={{ paddingInline: '25px' }}>
                <Stack direction="column" alignItems="flex-start" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        {language.cargo_partners_refund.titles.title}
                    </Typography>
                    <p style={{ color: '#D1D1D1', fontSize: '16px', fontWeight: '400' }}>
                        {partnerName} - {language.commons.labels.receive_ecommerce}
                    </p>
                    <HorizontalDivider />
                </Stack>

                {loading ? (
                    <Backdrop sx={{ color: '#fff', zIndex: 2, height: '100%' }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                ) : (
                    <>

                        {partner === "aras-kargo" &&
                            <>
                                <p style={{ color: 'black', fontWeight: '700', fontSize: '14px' }}>
                                    {partnerName} ile Çalışan Easypoint Noktaları
                                </p>
                                <Autocomplete
                                    id="company-autocomplete"
                                    options={companyList}
                                    getOptionLabel={(option) => option.title || ''}
                                    value={selectedCompany}
                                    onChange={(event, newValue) => setSelectedCompany(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={"Nokta Seç"}
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                    fullWidth
                                />
                            </>
                        }

                        <p style={{ color: 'black', fontWeight: '700', fontSize: '14px' }}>
                            {language.commons.enter_barcode}:
                        </p>
                        <TextField
                            placeholder={language.commons.enter_barcode}
                            variant="outlined"
                            fullWidth
                            value={barcode}
                            onChange={(e) => setBarcode(e.target.value)}
                            inputProps={{ maxLength: 34 }}
                        />

                        {partner === "aras-kargo" &&
                            <>
                                {(barcode.length !== 8 && barcode.length !== 34) &&
                                    <span style={{ color: '#da3831', fontSize: '12px', fontWeight: '400', marginTop: '5px' }}>
                                        Barkod 8 veya 34 haneli olmalıdır.
                                    </span>
                                }
                            </>
                        }


                        <Button
                            onClick={handleAcceptReturn}
                            style={{ marginTop: '50px' }}
                            sx={{
                                width: '100%',
                                backgroundColor: '#DC423C',
                                color: 'white',
                                marginTop: '21px',
                                height: '54px',
                                display: 'flex',
                                '&:hover': {
                                    backgroundColor: '#B53832'
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#DDDFE3',
                                },
                            }}
                            disabled={!allFieldsAreValid()}
                        >
                            {partner === "aras-kargo" ? "Kuryeden Zimmete Al" : "Teslim Al"}
                        </Button>
                    </>
                )}

                <Modal
                    open={isModalOpen}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: '8px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <img src={modalImage} alt="Sonuç" style={{ width: '60px', height: '60px', marginBottom: '20px' }} />
                        <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: '15px', fontWeight: '700', width: '200px', textAlign: 'center' }}>
                            {modalMessage}
                        </Typography>
                        <Button
                            onClick={handleCloseModal}
                            sx={{
                                width: '100%',
                                backgroundColor: '#DC423C',
                                color: 'white',
                                marginTop: '21px',
                                height: '54px',
                                display: 'flex',
                                '&:hover': {
                                    backgroundColor: '#B53832'
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#DDDFE3',
                                },
                            }}
                            fullWidth
                        >
                            Yeni İşlem Yap
                        </Button>
                    </Box>
                </Modal>
            </Stack>
        </>
    );
}
